import { Typography } from 'antd';

import styled from '@emotion/styled';

export const Title = styled(Typography.Title)`
  &.ui-typography {
    font-size: 20px;
    margin-bottom: 8px;
  }
`;
